import EmployeeView from "./EmployeeView";

export default EmployeeView